import { useState } from "react";
import BASE_URL from "./BASE_URL";

const MAX_ATTEMPTS = 3;
const BACKOFF_MS = [300, 800];

const useFetch = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async (url) => {
    let lastError;
    try {
      for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
        try {
          const response = await fetch(`${BASE_URL}${url}`);
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          const result = await response.json();
          setData(result);
          return result;
        } catch (err) {
          lastError = err;
          if (attempt < MAX_ATTEMPTS - 1) {
            await new Promise((r) => setTimeout(r, BACKOFF_MS[attempt]));
          }
        }
      }
      console.error(`useFetch(${url}) failed after ${MAX_ATTEMPTS} attempts:`, lastError);
      setError(lastError);
      throw lastError;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, fetchData };
};

export default useFetch;
